<template>
  <div>
    <video ref="videoRef" controls  preload="auto"  @play="playVideo" @pause="pauseVideo" @dblclick="toggleFullScreen">
      <source :src="videoUrl" type="video/mp4">
      视频加载失败(西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所
    </video>
  </div>
</template>

<script>
export default {
  name: "VideoPlayer",
  props: {
    videoUrl: {
      type: String,
      default: 0
    },
  },
  data() {
    return {
    };
  },
  methods: {
    playVideo(event) {
      event.preventDefault();
      this.$refs.videoRef.play();
    },
    pauseVideo(event) {
      event.preventDefault();
      this.$refs.videoRef.pause();
    },
    toggleFullScreen(event) {
      event.preventDefault();
      if (document.fullscreenEnabled) {
        if (document.fullscreenElement) {
          document.exitFullscreen();
        } else {
          this.$refs.videoRef.requestFullscreen();
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/base/VideoPlayer.vue